export const isPremiumCaptions = (status, user) => {
  return !!status && !!(
    status.audioStreams &&
    (user &&
      status.audioStreams.findIndex(
        elem => elem.usePaidASR && elem.avaId === user.avaId) !== -1) ||
    (status.asr && status.asr.googleCloud));
};

export const isUnlimitedPaidASR = (user, subscription) => {
  const {ongoingSubscription} = subscription;
  const fromFlag = !!user && !!user.features && user.features['google-cloud-asr'];
  const fromSubscription = !!ongoingSubscription &&
    ongoingSubscription !== 'Free' &&
    ongoingSubscription !== 'Freedom' &&
    subscription.ongoingSubscriptionSubtype !== 'Lite';
  return fromFlag || fromSubscription;
};

export const pendingScribe = (status) => !!status && !!status.scribe && status.scribe.status === 'pending';
export const hasScribe = (status) => !!status && !!status.scribe && status.scribe.status === 'ongoing';
export const isScribeRequestor = (status, user) => (
  !!status && !!status.scribe && !!status.scribe.requestor &&
  !!user && !!user.avaId && user.avaId === status.scribe.requestor);
export const hasRequestedScribe = (status, user) => (
  (hasScribe(status) || pendingScribe(status)) && isScribeRequestor(status, user));
export const isHost = (status, user) => !!status && !!status.host && !!user && status.host.avaId === user.avaId;


